import _ from 'lodash'

/**
 *  Checks if the current version is v5 or v6
 */

function isV5() {
	let localStorageVersion = localStorage.getItem('version')
	// #60659 #62873 if no version is set, assume v5
	return _.isNil(localStorageVersion) || localStorageVersion === 'v5'
}

function isV6() {
	return localStorage.getItem('version') === 'v6'
}

export {isV5, isV6}
